// v10/src/components/HUDBackground.js
// Fondo HUD Nocturno — CSS puro, sin canvas ni librerías pesadas
import React from 'react';

const HUDBackground = () => {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 0,
      // ✅ overflow:hidden eliminado — rompe backdrop-filter en Safari iOS
      background: 'linear-gradient(160deg, #0a0f1e 0%, #0d1b3e 40%, #0a192f 100%)',
      WebkitBackfaceVisibility: 'hidden', // iOS Safari fix sin romper stacking context
    }}>
      <style>{`
        /* Grilla técnica */
        .hud-grid {
          position: absolute; inset: 0;
          background-image:
            linear-gradient(rgba(59,130,246,0.06) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59,130,246,0.06) 1px, transparent 1px);
          background-size: 44px 44px;
        }

        /* Línea de horizonte */
        .hud-horizon {
          position: absolute; top: 56%; left: 0; right: 0; height: 1px;
          background: linear-gradient(to right,
            transparent 0%,
            rgba(59,130,246,0.35) 15%,
            rgba(99,102,241,0.5) 50%,
            rgba(59,130,246,0.35) 85%,
            transparent 100%
          );
        }
        .hud-horizon::before {
          content: 'HDG 270°';
          position: absolute; top: -10px; left: 50%; transform: translateX(-50%);
          font-family: 'Courier New', monospace; font-size: 9px; font-weight: 700;
          color: rgba(99,102,241,0.5); letter-spacing: 0.15em;
        }

        /* Círculos HUD */
        .hud-ring {
          position: absolute; border-radius: 50%;
          border: 1px solid rgba(59,130,246,0.12);
          top: 50%; left: 50%; transform: translate(-50%, -50%);
          animation: hud-pulse 5s ease-in-out infinite;
        }
        .hud-ring:nth-child(1) { width: 320px; height: 320px; border-color: rgba(59,130,246,0.18); animation-delay: 0s; }
        .hud-ring:nth-child(2) { width: 550px; height: 550px; animation-delay: -1.7s; }
        .hud-ring:nth-child(3) { width: 780px; height: 780px; animation-delay: -3.3s; border-color: rgba(59,130,246,0.07); }
        @keyframes hud-pulse {
          0%, 100% { opacity: 0.4; }
          50%       { opacity: 1; }
        }

        /* Líneas de cruz central */
        .hud-cross-h, .hud-cross-v {
          position: absolute;
          background: rgba(99,102,241,0.15);
        }
        .hud-cross-h { top: 50%; left: 0; right: 0; height: 1px; transform: translateY(-50%); }
        .hud-cross-v { left: 50%; top: 0; bottom: 0; width: 1px; transform: translateX(-50%); }

        /* Datos HUD flotantes */
        .hud-data {
          position: absolute;
          font-family: 'Courier New', monospace;
          font-size: 10px; font-weight: 700; letter-spacing: 0.12em;
          color: rgba(96,165,250,0.45);
          line-height: 1.6;
          animation: hud-blink 4s ease-in-out infinite;
        }
        .hud-data-tl { top: 12%; left: 4%; animation-delay: 0s; }
        .hud-data-tr { top: 12%; right: 4%; text-align: right; animation-delay: -1s; }
        .hud-data-bl { bottom: 15%; left: 4%; animation-delay: -2s; }
        .hud-data-br { bottom: 15%; right: 4%; text-align: right; animation-delay: -0.5s; }
        @keyframes hud-blink {
          0%, 100% { opacity: 0.35; }
          50%       { opacity: 0.75; }
        }

        /* Ruta de vuelo */
        .hud-route {
          position: absolute; top: 56%; left: 8%; right: 8%; height: 1px;
          background: linear-gradient(to right,
            transparent,
            rgba(99,102,241,0.3) 20%,
            rgba(99,102,241,0.3) 80%,
            transparent
          );
        }

        /* Waypoints */
        .hud-wp {
          position: absolute; top: 56%; margin-top: -3px;
          width: 6px; height: 6px; border-radius: 50%;
          background: rgba(99,102,241,0.7);
          box-shadow: 0 0 8px rgba(99,102,241,0.9);
          transform: translateY(-50%);
        }
        .hud-wp::after {
          content: ''; position: absolute;
          top: -5px; left: -5px; right: -5px; bottom: -5px;
          border-radius: 50%; border: 1px solid rgba(99,102,241,0.4);
          animation: hud-ping 2.5s ease-out infinite;
        }
        .hud-wp:nth-child(1) { left: 22%; animation-delay: 0s; }
        .hud-wp:nth-child(2) { left: 47%; animation-delay: -0.8s; }
        .hud-wp:nth-child(3) { left: 73%; animation-delay: -1.6s; }
        @keyframes hud-ping {
          0%   { transform: scale(1); opacity: 0.8; }
          100% { transform: scale(3.5); opacity: 0; }
        }

        /* Avión volando */
        .hud-plane {
          position: absolute; top: 52%; font-size: 20px;
          color: #93c5fd;
          filter: drop-shadow(0 0 10px rgba(147,197,253,0.9));
          animation: hud-fly 20s linear infinite;
          transform: translateY(-50%);
        }
        @keyframes hud-fly {
          0%   { left: -4%; opacity: 0; }
          5%   { opacity: 1; }
          95%  { opacity: 1; }
          100% { left: 104%; opacity: 0; }
        }

        /* Estrellas estáticas en la parte superior */
        .hud-stars {
          position: absolute; inset: 0;
          background-image:
            radial-gradient(1px 1px at 8%  8%,  rgba(255,255,255,0.6) 0%, transparent 100%),
            radial-gradient(1px 1px at 20% 4%,  rgba(255,255,255,0.4) 0%, transparent 100%),
            radial-gradient(1px 1px at 35% 12%, rgba(255,255,255,0.7) 0%, transparent 100%),
            radial-gradient(1px 1px at 52% 6%,  rgba(255,255,255,0.5) 0%, transparent 100%),
            radial-gradient(1px 1px at 68% 9%,  rgba(255,255,255,0.6) 0%, transparent 100%),
            radial-gradient(1px 1px at 82% 3%,  rgba(255,255,255,0.4) 0%, transparent 100%),
            radial-gradient(1px 1px at 92% 14%, rgba(255,255,255,0.7) 0%, transparent 100%),
            radial-gradient(1.5px 1.5px at 15% 22%, rgba(147,197,253,0.4) 0%, transparent 100%),
            radial-gradient(1px 1px at 44% 18%, rgba(255,255,255,0.3) 0%, transparent 100%),
            radial-gradient(1px 1px at 78% 25%, rgba(255,255,255,0.4) 0%, transparent 100%),
            radial-gradient(1px 1px at 30% 30%, rgba(255,255,255,0.2) 0%, transparent 100%),
            radial-gradient(1px 1px at 60% 35%, rgba(147,197,253,0.3) 0%, transparent 100%);
        }

        /* Brillo central sutil */
        .hud-glow {
          position: absolute; top: 30%; left: 50%; transform: translate(-50%, -50%);
          width: 600px; height: 300px;
          background: radial-gradient(ellipse, rgba(59,130,246,0.06) 0%, transparent 70%);
          pointer-events: none;
        }
      `}</style>

      <div className="hud-stars" />
      <div className="hud-grid" />
      <div className="hud-glow" />

      {/* Anillos */}
      <div className="hud-ring" />
      <div className="hud-ring" />
      <div className="hud-ring" />

      {/* Cruz central */}
      <div className="hud-cross-h" />
      <div className="hud-cross-v" />

      {/* Horizonte */}
      <div className="hud-horizon" />

      {/* Datos */}
      <div className="hud-data hud-data-tl">
        ALT: 8.500 FT<br/>
        VS: +500 FPM<br/>
        OAT: -12°C
      </div>
      <div className="hud-data hud-data-tr">
        IAS: 124 KT<br/>
        TAS: 138 KT<br/>
        MACH: 0.21
      </div>
      <div className="hud-data hud-data-bl">
        QNH: 1.013 hPa<br/>
        WIND: 270° / 13KT<br/>
        DIST: 48 NM
      </div>
      <div className="hud-data hud-data-br">
        ETA: +00:24<br/>
        FUEL: 4.2 H<br/>
        GS: 131 KT
      </div>

      {/* Ruta y waypoints */}
      <div className="hud-route" />
      <div className="hud-wp" />
      <div className="hud-wp" />
      <div className="hud-wp" />

      {/* Avión */}
      <div className="hud-plane">✈</div>
    </div>
  );
};

export default HUDBackground;
